import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class CustomerService {
	public selectedCustomer;
	public selectedCustomer$: EventEmitter<any>;

	constructor(private _http: HttpClient) {
		this.selectedCustomer$ = new EventEmitter();
	}

	/**
	 * @api {post} /v2/InetCustomers Create Account
	 * @apiName createAccount
	 * @apiGroup InetCustomers
	 * @apiVersion 20.0.0
	 */
	createAccount(data) {
		return this._http.post<any>(`${environment.apiUrl}/v2/InetCustomers`, JSON.stringify(data));
	}

	/**
	 * @api {get} /v3/Customers Get Customers
	 * @apiName getAllowedCustomers
	 * @apiGroup Customers
	 * @apiVersion 22.7.0
	 */
	getAllowedCustomers() {
		return this._http.get<any>(`${environment.apiUrl}/v3/Customers`);
	}

	/**
	 * @api {get} /v2/Customers/:id Get Customer
	 * @apiName getCustomer
	 * @apiGroup Customers
	 * @apiVersion 20.0.0
	 */
	getCustomer(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Customers/${id}`);
	}

	/**
	 * @api {get} /v2/Customers/:id/StatusEvents Get Customer Status Events
	 * @apiName getCustomerStatusEvents
	 * @apiGroup Customers
	 * @apiVersion 20.0.0
	 */
	getCustomerStatusEvents(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Customers/${id}/StatusEvents`);
	}

	getSelectedCustomer() {
		return this.selectedCustomer = JSON.parse(localStorage.getItem('Rapidship:customer'));
	}

	updateSelectedCustomer(customer) {
		if (customer) {
			localStorage.setItem('Rapidship:customer', JSON.stringify(customer));
			this.selectedCustomer$.emit(customer);
		}
	}
}
